<template>
  <div class="v2-sales-analytics-page">
    <!-- Header -->
    <div class="v2-flex v2-items-center v2-justify-between v2-mb-6">
      <h1 class="v2-heading-sm">
        Sales Insights
      </h1>
      <v2-sales-analytics-filter @filter-by-date="onFilterByDate" />
    </div>

    <!-- Loading -->
    <div
      v-if="isLoading"
      class="v2-page-loading"
    >
      <v2-spinner
        size="lg"
        label="Loading..."
      />
    </div>

    <!-- Data -->
    <template v-else-if="totalSelections">
      <v2-sales-analytics-list
        :selections="selectionList"
        :get-date-and-time="getDateAndTime"
        @click-selection="onSelectionClick"
      />
      <v2-pagination
        :current-page="pageNumber"
        :total-items="totalSelections"
        :per-page="perPage"
        @page-change="onPageChange"
      />
    </template>

    <!-- Empty state -->
    <v2-card
      v-else
      class="v2-text-center v2-p-8 v2-mt-4"
    >
      <svg
        width="48"
        height="48"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="v2-sales-analytics-page__empty-icon"
      >
        <circle
          cx="11"
          cy="11"
          r="8"
        />
        <line
          x1="21"
          y1="21"
          x2="16.65"
          y2="16.65"
        />
      </svg>
      <p class="v2-text-muted v2-mt-4">
        No selection has been shared.
        <a
          class="v2-sales-analytics-page__link"
          @click="routeToShareSelection"
        >Click here</a>
        to share your selection.
      </p>
    </v2-card>
  </div>
</template>

<script>
import V2Spinner from '@/components/v2/V2Spinner.vue'
import V2Card from '@/components/v2/V2Card.vue'
import V2Pagination from '@/components/v2/V2Pagination.vue'
import { useSalesAnalytics } from '@/composables/useSalesAnalytics'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import V2SalesAnalyticsFilter from './V2SalesAnalyticsFilter.vue'
import V2SalesAnalyticsList from './V2SalesAnalyticsList.vue'

export default {
  name: 'V2SalesAnalytics',
  components: {
    V2Spinner,
    V2Card,
    V2Pagination,
    V2SalesAnalyticsFilter,
    V2SalesAnalyticsList,
  },
  setup() {
    const sa = useSalesAnalytics()
    sa.initSalesAnalytics()
    // Destructure router-dependent fns out of spread to avoid setup/methods name collision
    const { routeToShareSelection, onClickSelection, ...rest } = sa
    return { ...rest }
  },
  methods: {
    routeToShareSelection() {
      this.$router.push({ name: 'v2-selection' })
      analytics.track(constants.TRACKS.ACTIONS.BRNAD_CLICKS_CLICK_HERE_HYPERLINK_IN_SALES_INSIGHTS_PAGE)
    },
    onSelectionClick(selection) {
      this.$router.push({ name: 'v2-selection-products', params: { wishlistId: selection.selectionId } })
      analytics.track(constants.TRACKS.ACTIONS.BRAND_CLICKS_A_SELECTION_IN_SALES_INSIGHTS_PAGE, { selection })
    },
    onPageChange(page) {
      this.pageNumber = page
      this.onApplyPagination()
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-sales-analytics-page {
  &__empty-icon {
    color: var(--v2-muted-foreground);
    margin: 0 auto;
    display: block;
  }

  &__link {
    color: var(--v2-primary);
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }
}
</style>
